import { configureStore } from '@reduxjs/toolkit';

import { authSlice } from '@app/store/reducers/auth';
import { clsSlice } from '@app/store/reducers/cls';
import { icdSlice } from '@app/store/reducers/icd';
import { nccSlice } from '@app/store/reducers/ncc';
import { uiSlice } from '@app/store/reducers/ui';
import { captureSlice } from '@app/store/reducers/captureSlice';
import { trangthaiSlice } from '@app/store/reducers/trangthaiSlice';
const store = configureStore({
	reducer: {
		auth: authSlice.reducer,
		cls: clsSlice.reducer,
		icd: icdSlice.reducer,
		ncc: nccSlice.reducer,
		ui: uiSlice.reducer,
		ttSliceName: trangthaiSlice.reducer,
		captureSlice: captureSlice.reducer,
	},
});

export default store;
